<template>
  <div class="md-layout">
    <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-large-size-80 md-xlarge-size-70 page-container">
      <div class="md-layout">
        <div class="md-layout-item md-size-20 md-small-size-100 page-container-side text-right">
          <div>
            <h3>{{$t('your-enquiry')}}</h3>
          </div>
        </div>
        <div class="md-layout-item md-size-80 md-small-size-100" id="your-enquiry">
          <div class="page-container-section">
            <!-- Enquiry Select & Order Number Input -->
            <div>
              <div class="md-layout md-gutter">
                <!-- Nature of Enquiry droplist -->
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-field>
                    <label for="natureEnquiry">{{$t('nature-enquiry')}}</label>
                    <md-select v-model="form.natureEnquiry" id="natureEnquiry" name="natureEnquiry" md-dense :disabled="sending" v-on:input="changeServiceRequired" >
                      <md-option :value="item.id" v-for="item in natureEnquiry" v-bind:key="item.id" v-show="!((store=='jp' || store=='tw' || store=='asean' ) && item.key=='return-product')" >{{item.name}}</md-option>
                    </md-select>
                  </md-field>
                </div>
                <!-- Order Number input -->
                <div class="md-layout-item md-size-50 md-small-size-100" v-if="form.natureEnquiry==1 && formMode=='estore' && (!orderList || orderList.length <= 1)">
                  <md-field :class="getValidationClass('orderNumber')">
                    <label for="orderNumber">{{$t('order-number')}}</label>
                    <md-input name="orderNumber" id="orderNumber" v-model="form.orderNumber" :disabled="sending" v-on:keyup.enter="searchOrder" v-on:input="resetForm()" />
                    <span class="md-error" v-if="!$v.form.orderNumber.required">{{$t('enter-order-number')}}</span>
                  </md-field>
                </div>
                <!-- Order Number select -->
                <div class="md-layout-item md-size-50 md-small-size-100" v-if="form.natureEnquiry==1 && formMode=='estore' && (orderList && orderList.length > 1)">
                  <md-field>
                    <label for="orderNumber">{{$t('order-number')}}</label>
                    <md-select v-model="form.orderNumber" id="orderNumber" name="orderNumber" md-dense :disabled="sending" v-on:input="changeOrder()">
                      <md-option :value="item" v-for="item in orderList" v-bind:key="item">{{item}}</md-option>
                    </md-select>
                  </md-field>
                </div>
                <!-- RMA Number input -->
                <div class="md-layout-item md-size-50 md-small-size-100" v-if="form.natureEnquiry==4&&(!rmaNumberList||rmaNumberList.length<=1)">
                  <md-field :class="getValidationClass('rmaNumber')">
                    <label for="rmaNumber">{{$t('rma-number')}}</label>
                    <md-input name="rmaNumber" id="rmaNumber" v-model="form.rmaNumber" :disabled="sending" v-on:keyup.enter="searchRMA" v-on:input="changeRMANo()" v-on:change="changeRMANo()" />
                    <span class="md-error" v-if="!$v.form.rmaNumber.required">{{$t('enter-rma-number')}}</span>
                  </md-field>
                </div>
                <!-- RMA Number select -->
                <div class="md-layout-item md-size-50 md-small-size-100" v-if="form.natureEnquiry==4&&(rmaNumberList&&rmaNumberList.length>1)">
                  <md-field>
                    <label for="rmaNumber">{{$t('rma-number')}}</label>
                    <md-select v-model="form.rmaNumber" id="rmaNumber" name="rmaNumber" md-dense :disabled="sending" v-on:input="changeRMANo()">
                      <md-option :value="item" v-for="item in rmaNumberList" v-bind:key="item">{{item}}</md-option>
                    </md-select>
                  </md-field>
                </div>
              </div>
              <!-- Text description for not purchase creative.com -->
              <div class="md-layout md-gutter md-alignment-top-right" v-if="form.natureEnquiry==1">
                <div class="md-layout-item md-size-50 md-small-size-100" style="margin-top:-10px;">
                  <div class="md-helper-text order-msg" v-html="$t('not-purchase-creative-com')"></div>
                  <!-- <div class="md-helper-text" v-if="form.natureEnquiry==2 && formMode == 'estore'"><span v-html="$t('not_purchase_creative_com_2.text')"></span> <a href="javascript:;" v-on:click="changeFormMode('retail')">{{$t('not_purchase_creative_com_2.link')}}</a></div> -->
                </div>
              </div>
              <!-- Message order no found -->
              <div class="md-layout md-gutter md-alignment-top-right" v-if="form.natureEnquiry==1&&orderNoFound">
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <div><span class="md-error">{{$t('order-not-found')}}</span></div>
                </div>
              </div>
              <!-- Message RMA no found -->
              <div class="md-layout md-gutter md-alignment-top-right" v-if="rmaNoFound">
                <div class="md-layout-item md-size-50 md-small-size-100" style="margin-top:-20px;">
                  <span class="md-error">{{$t('rma-not-found')}}</span>
                </div>
              </div>
              <!-- Purchase From -->
              <div class="md-layout  md-gutter" v-if="form.natureEnquiry==2">
                <!-- Radio select -->
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100">
                      <p><strong>{{$t('product-purchased-from')}}</strong> </p>
                    </div>
                    <div class="md-layout-item md-size-100 select-source">
                      <md-radio v-model="formMode" value="estore" v-on:change="scrollToSection();changeStep(2)">{{$t('creative-store')}}</md-radio>
                      <md-radio v-model="formMode" value="retail" v-on:change="scrollToSection();changeStep(2)" v-if="showRetailer"><span v-html="$t('all-other-retailers')"></span></md-radio>
                    </div>
                  </div>
                </div>
                <!-- Order input -->
                <div class="md-layout-item md-size-50 md-small-size-100" style="padding-top:35px;">
                  <!-- Order Number input -->
                  <div v-if="form.natureEnquiry==2 && formMode=='estore' && (!orderList || orderList.length <= 1)">
                    <md-field :class="getValidationClass('orderNumber')">
                      <label for="orderNumber">{{$t('order-number')}}</label>
                      <md-input name="orderNumber" id="orderNumber" v-model="form.orderNumber" :disabled="sending" v-on:keyup.enter="searchOrder" v-on:input="resetForm()" />
                      <span class="md-error" v-if="!$v.form.orderNumber.required">{{$t('enter-order-number')}}</span>
                    </md-field>
                    <div v-if="form.natureEnquiry==2">
                      <div class="md-helper-text retail-msg">
                        <!-- Message order no found -->
                        <div v-if="form.natureEnquiry==2&&orderNoFound" class="md-error">{{$t('order-not-found')}}</div>
                        <div v-if="!showRetailer" v-html="$t('not-purchase-creative-com-retailer-replacement')"></div>
                      </div>
                    </div>
                  </div>
                  <!-- Order Number select -->
                  <div v-if="form.natureEnquiry==2 && formMode=='estore' && (orderList && orderList.length > 1)">
                    <md-field>
                      <label for="orderNumber">{{$t('order-number')}}</label>
                      <md-select v-model="form.orderNumber" id="orderNumber" name="orderNumber" md-dense :disabled="sending" v-on:input="changeOrder()">
                        <md-option :value="item" v-for="item in orderList" v-bind:key="item">{{item}}</md-option>
                      </md-select>
                    </md-field>
                  </div>
                </div>
              </div>
              <!-- Button next -->
              <div class="md-layout md-gutter" v-if="formMode=='estore'&&(!orderList||orderList.length==0||form.natureEnquiry==4||showRetailer)">
                <div class="md-layout-item text-right" style="padding-top:20px;">
                  <md-button class="md-accent md-raised" v-on:click="searchOrder" :disabled="sending">
                    {{$t('next')}} <md-progress-spinner class="md-primary" md-mode="indeterminate" :md-value="80" :md-diameter="14" :md-stroke="2" v-if="sending"></md-progress-spinner>
                  </md-button>
                </div>
              </div>
            </div>
            <!-- RMA Status -->
            <div v-if="form.natureEnquiry==4 && formMode=='rma-status'">
              <div class="md-layout">
                <div class="md-layout-item md-size-100">
                  <request-steppers :detail="rmaDetail" />
                </div>
                <div class="md-layout-item md-size-100 text-right" v-if="step==2">
                  <!-- Contact button -->
                  <md-button class="md-accent md-raised" v-on:click="contactus" :disabled="sending">
                    {{$t('contact-us')}} <md-progress-spinner class="md-primary" md-mode="indeterminate" :md-value="80" :md-diameter="14" :md-stroke="2" v-if="sending"></md-progress-spinner>
                  </md-button>
                </div>
              </div>
            </div>
            <!-- Order Detail -->
            <div v-if="orderList&&orderList.length>0&&formMode=='estore'&&form.natureEnquiry!=4">
              <div class="md-layout md-gutter md-alignment-bottom-left">
                <div class="md-layout-item md-size-50">
                  <p><strong>{{$t('your-order')}}: {{form.orderNumber}}</strong></p>
                  <p v-if="orderList.length>1">
                    <md-button v-on:click="perviousOrder" :disabled="orderList.indexOf(form.orderNumber)==orderList.length-1">« {{$t('previous-order')}}</md-button>
                  </p>
                </div>
                <div class="md-layout-item md-size-50 text-right">
                  <p v-if="orderList.length>1">
                    <md-button v-on:click="nextOrder" :disabled="orderList.indexOf(form.orderNumber)==0">{{$t('next-order')}} »</md-button>
                  </p>
                </div>
              </div>
              <div class="md-layout">
                <div class="md-layout-item">
                  <product-table :products="productSelect" :type="'estore'" :action="form.natureEnquiry" v-on:refresh="refreshOrder()" />
                </div>
              </div>
            </div>
            <!-- Product Search -->
            <div v-if="formMode=='retail' &&  showRetailer">
              <div class="md-layout" :style="'padding-bottom:'+ retailList&&retailList.length>0 ? 0 :160 +'px;'">
                <div class="md-layout-item md-size-100">
                  <h3 class="page-sub-title">{{$t('add-your-product')}}</h3>
                </div>
                <div class="md-layout-item md-size-100">
                  <div>
                    <md-autocomplete v-model="form.search"
                                     :md-options="products"
                                     md-dense
                                     md-layout="box"
                                     :md-fuzzy-search="false"
                                     :md-open-on-focus="true"
                                     @md-selected="searchProduct"
                                     @md-opened="scrollToSection">
                      <label>{{$t('search-by-name')}}</label>
                    </md-autocomplete>
                  </div>
                </div>
                <div v-if="!retailList || retailList.length == 0" style="height:400px;"></div>
              </div>
              <div class="md-layout" v-if="retailList&&retailList.length>0">
                <div class="md-layout-item">
                  <product-table :products="retailList" :type="'retail'" :action="2" v-on:refresh="refreshRetailList()" />
                </div>
              </div>
            </div>
            <!-- Next Button -->
            <div v-if="form.natureEnquiry!=4">
              <div class="md-layout" v-if="showSelectProductMsg">
                <div class="md-layout-item md-error text-right">{{$t('select-product')}}</div>
              </div>
              <div class="md-layout" v-if="showUploadFileMsg">
                <div class="md-layout-item md-error text-right">
                  <span v-html="$t('upload-proof-update-date.text1')"></span><a href="javascript:;" style="text-decoration:underline" v-on:click="contactUsForProof">{{$t('upload-proof-update-date.link')}}</a>{{$t('upload-proof-update-date.text2')}}
                </div>
              </div>
              <div class="md-layout" v-if="showSerialNumMsg">
                <div class="md-layout-item md-error text-right">{{$t('enter-serial-number')}}</div>
              </div>
              <div class="md-layout md-gutter" v-if="step==2&&((orderList&&orderList.length>0&&formMode=='estore')||(retailList&&retailList.length>0&&formMode=='retail'))">

                <div class="md-layout-item text-right" style="padding-top:20px;">
                  <md-button class="md-accent md-raised" v-on:click="submit" :disabled="sending">
                    {{$t('next')}} <md-progress-spinner class="md-primary" md-mode="indeterminate" :md-value="80" :md-diameter="14" :md-stroke="2" v-if="sending"></md-progress-spinner>
                  </md-button>
                </div>
              </div>
            </div>
            <md-snackbar :md-active.sync="showErrorMsg" :md-duration="8000">{{$t('encountered-error')}}</md-snackbar>
            <md-snackbar :md-active.sync="showMaxLimitMsg" :md-duration="8000">{{$t('selected-maximum')}}</md-snackbar>
          </div>
        </div>
      </div>
      <full-page-loading :show="fullPageLoading" :error="showErrorMsg" />
    </div>
  </div>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import ProductTable from '../components/ProductTable'
  import Auth from '../mixins/auth'
  import {
    required
  } from 'vuelidate/lib/validators'
  import { mapState, mapMutations } from 'vuex'
  import * as types from '../store/mutation-types'
  import RequestSteppers from '../components/RequestSteppers'
  import { apiServer } from '../config'
  import FullPageLoading from '../components/FullPageLoading'

  export default {
    name: 'YourProducts',
    mixins: [validationMixin],
    components: {
      ProductTable,
      RequestSteppers,
      FullPageLoading
    },
    data: () => ({
      form: {
        natureEnquiry: 1,
        orderNumber: '',
        rmaNumber: '',
        search: ''
      },
      loading: false,
      sending: false,
      showErrorMsg: false,
      natureEnquiry: [
        { id: 1, name:'', key: 'return-product' },
        { id: 2, name:'', key: 'replace-defective-product' },
        { id: 4, name:'', key: 'check-rma-status'}
      ],
      orderList: [],
      rmaNumberList: [],
      allOrders: [],
      retailList: [],
      productSelect: [],
      products: [],
      orderNoFound: false,
      rmaNoFound: false,
      formMode: 'estore',
      showSelectProductMsg: false,
      showUploadFileMsg: false,
      showSerialNumMsg: false,
      showRetailer: false,
      rmaDetail: null,
      fullPageLoading: true,
      showMaxLimitMsg: false
    }),
    validations: {
      form: {
        orderNumber: {
          required
        },
        rmaNumber: {
          required
        }
      }
    },
    computed: {
      ...mapState({
        store: 'store',
        step: 'step',
        productSelected: 'prodList',
        orderSelectedCount: 'orderSelectedCount',
        retailSelectedCount: 'retailSelectedCount'
      })
    },
    async created() {
      this.loading = true
      this.showPageLoading()

      // Hide the "Return/Replacement" selection, default to "RMA Status" only (Temp disable for CA)
      //if (this.store === 'ca') {
      //  this.natureEnquiry= [
      //    { id: 4, name: '', key: 'check-rma-status' }
      //  ]
      //}

      // This is to get the localization text from rss, set by the natureEnquiry above
      for (let item in this.natureEnquiry) {
        this.natureEnquiry[item].name = this.$t(this.natureEnquiry[item].key)
      }
      window.console.log(this.$route )

       // Hide the "Return Product" selection (initialize)
      if (this.store === 'asean' || this.store === 'jp' || this.store === 'tw') {
        this.form.natureEnquiry = 2
      }

      const r = await this.$http.request({ url: `${apiServer}/api/your-products?store=` + this.store, method: 'get', headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).catch(() => { this.loading = false })
      if (r && r.status == 200) {
        if (r.data) {
          if (r.data.orderList) {
            this.allOrders = r.data.orderList
            this.orderList = []
            this.allOrders.forEach(a => { this.orderList.push(a.orderNumber) })
            if (r.data.selected) this.selectProduct(r.data.selected)
            else this.selectProduct([])
            this.form.orderNumber = r.data.orderNumber
            if (this.orderList && this.orderList.length > 0 && this.orderList.indexOf(this.form.orderNumber) == -1) this.form.orderNumber = this.orderList[0]
            this.form.rmaNumber = r.data.rmaNumber
            this.showRetailer = r.data.showRetailer
            this.loadOrderDetail()
            if (!this.showRetailer)
              this.loadRetailDetail()
          }
          if (r.data.rmaNumberList && r.data.rmaNumberList.length>0) {
            this.rmaNumberList = r.data.rmaNumberList
          }
          if (r.data.suggest) this.products = r.data.suggest
          if (r.data.action) this.form.natureEnquiry = parseInt(r.data.action)

          // Hide the "Return Product" selection  (Set default to "replacement")
          if (this.store === 'asean' || this.store === 'jp' || this.store === 'tw') {
            this.form.natureEnquiry = 2
          }


          // contact us for proof of purchase
          if (this.form.natureEnquiry == 5) this.form.natureEnquiry = 2
       //   let routeType = false
          if (this.$route.params.type && this.$route.params.type.length > 0)  {
            switch(this.$route.params.type) {
              case 'return':
                this.form.natureEnquiry = 1
                break
              case 'replacement':
                this.form.natureEnquiry = 2
                break
              case 'rma-status':
                this.form.natureEnquiry = 4
                break
            }
         //   routeType = true
          }
          if (this.form.natureEnquiry == 2 && (!r.data.orderNumber || r.data.orderNumber.length == 0)) {
            this.formMode = 'retail'
          }
          // restore from localstorage
          // if (!routeType && localStorage.rma_step2_enquiry) this.form.natureEnquiry = localStorage.rma_step2_enquiry ? parseInt(localStorage.rma_step2_enquiry) : 0
          // if (!routeType && localStorage.rma_step2_formMode) {
          //   this.formMode = localStorage.rma_step2_formMode
          //   this.changeFormMode(this.formMode)
          // }
        }
        this.loading = false
        this.hidePageLoading()
        this.fullPageLoading = false

        if (!this.showRetailer) {
          this.formMode = 'estore'
          this.changeStep(2)
        }

        if(!this.orderList || this.orderList.length == 0) this.autoSearch()
      }
      else {
        this.changeStep(1)
        this.loading = false
        this.showErrorMsg = true
        this.hidePageLoading()
        this.fullPageLoading = false
      }
    },
    methods: {
      ...mapMutations({
        changeStore: types.CHANGE_STORE,
        changeStep: types.CHANGE_STEP,
        selectProduct: types.SELECT_PRODUCT,
        selectOrderCount: types.SELECT_ORDER_COUNT,
        selectRetailCount: types.SELECT_RETAIL_COUNT,
        showPageLoading: types.SHOW_LOADING,
        hidePageLoading: types.HIDE_LOADING
      }),
      getValidationClass(fieldName) {
        const field = this.$v.form[fieldName]
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      select() {
        this.sending = true
      },
      searchOrder() {
        this.$v.$touch()
        if (this.form.natureEnquiry <= 2 && this.form.orderNumber && this.form.orderNumber.length > 0) {
          this.showPageLoading()
          this.sending = true
          this.orderNoFound = false
          this.$http.post(`${apiServer}/api/your-products/search-order`, { keyword: this.form.orderNumber, store: this.store }, { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).then(({ data }) => {
            if (data && data.orderList) {
              if (data.orderList.length == 0) {
                this.orderNoFound = true
                setTimeout(() => { this.orderNoFound = false }, 1000*8)
              }
              else {
                this.allOrders = data.orderList
                this.orderList = []
                this.allOrders.forEach(a => { this.orderList.push(a.orderNumber) })
                if (this.orderList.length > 0) this.form.orderNumber = this.orderList[0]
                this.loadOrderDetail()
              }
            }
            this.sending = false
            this.hidePageLoading()
          }).catch(() => {
            this.sending = false
            this.showErrorMsg = true
            this.hidePageLoading()
          })
        }
        if (this.form.natureEnquiry == 4 && this.form.rmaNumber && this.form.rmaNumber.length > 0) {
          this.showPageLoading()
          this.sending = true
          this.$http.post(`${apiServer}/api/your-products/search-rma-request`, { keyword: this.form.rmaNumber, store: this.store }, { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).then(({ data }) => {
            if (data && data.status == 'success') {
              this.formMode = 'rma-status',
              this.rmaDetail = data.detail
            }
            else {
              this.rmaNoFound = true
              setTimeout(() => { this.rmaNoFound = false }, 1000 * 8)
            }
            this.sending = false
            this.hidePageLoading()
          }).catch(() => {
            this.sending = false
            this.showErrorMsg = true
            this.hidePageLoading()
          })
        }
      },
      searchRMA() {
        this.searchOrder()
      },
      autoSearch() {
        if (
          (this.form.orderNumber && this.form.orderNumber.length > 0) ||
          (this.form.rmaNumber && this.form.rmaNumber.length > 0)
        ) {
          this.searchOrder()
        }
      },
      searchProduct(searchTerm) {
        this.showPageLoading()
        this.$http.post(`${apiServer}/api/your-products/select`, { keyword: searchTerm, store: this.store }, { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).then(({ data }) => {
          this.hidePageLoading()
          if (data &&  data.status == 'max-qty-limit')
          {
            this.showMaxLimitMsg = true
          }
          else if (data && data.products) {
            this.selectProduct(data.products)
            this.loadRetailDetail()
          }
        }).catch(() => {
          this.hidePageLoading()
          this.showErrorMsg = true
        })
      },
      async getProducts(searchTerm) {
        const r = await this.$http.post(`${apiServer}/api/your-products/search`, { keyword: searchTerm, store: this.store }, { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).catch(() => { })
        if (r && r.status == 200 && r.data) {
          this.products = r.data
        }
      },
      showSerialNum() {
        this.showSerialNumberForm = true
      },
      changeOrder() {
        this.loadOrderDetail()
        this.changeStep(2)
      },
      changeRMANo() {
        this.formMode = 'estore'
        this.rmaDetail = null
      },
      resetForm() {
        this.orderList = []
      },
      nextOrder() {
        const index = this.orderList.indexOf(this.form.orderNumber)
        if (index >= 1) {
          const o = this.orderList[index - 1]
          this.form.orderNumber = o
          this.loadOrderDetail()
          this.changeStep(2)
        }
      },
      perviousOrder() {
        const index = this.orderList.indexOf(this.form.orderNumber)
        if (index >= 0 && index < this.orderList.length - 1) {
          const o = this.orderList[this.orderList.indexOf(this.form.orderNumber) + 1]
          this.form.orderNumber = o
          this.loadOrderDetail()
          this.changeStep(2)
        }
      },
      loadOrderDetail() {
        if (this.form.orderNumber && this.form.orderNumber.length > 0) {
          let count = 0
          this.productSelect = []
          const order = this.allOrders.filter(a => { return a.orderNumber == this.form.orderNumber })
          if (order && order.length >= 1) {
            for (let i = 0; i < order[0].items.length; i++) {
              const item = order[0].items[i]
              const selected = this.productSelected.filter(a => { return a.sourceId == item.sourceId })
              let newItem = { ...item }
              newItem.orderNumber = order[0].orderNumber
              newItem.selected = false
              if (selected != null && selected.length > 0) {
                newItem.selected = selected[0].actionSelected == this.form.natureEnquiry ? true : false
                if (newItem.selected) count++
                newItem.serialNumber = selected[0].serialNumber ? selected[0].serialNumber : ''
                newItem.serialNumberLocked = selected[0].serialNumberLocked
                newItem.serialNumberFinish = selected[0].serialNumber && selected[0].serialNumber.length > 0 ? true : false
              }
//              window.console.log(newItem)
              this.productSelect.push(newItem)
            }
          }
          this.selectOrderCount(count)
        }
     //   this.changeStep(2)
      },
      loadRetailDetail() {
        this.retailList = []
        const list = this.productSelected.filter(a => { return a.orderNumber == null || a.orderNumber.length == 0 })
        let count = 0
        list.forEach(a => {
          let newItem = { ...a }
          newItem.selected = a.actionSelected == 2 ? true : false
          if (newItem.selected) count++
          newItem.serialNumberFinish = a.serialNumber && a.serialNumber.length > 0 ? true : false
          newItem.invoiceNumberFinish = a.invoiceNumber && a.invoiceNumber.length > 0 ? true : false
          this.retailList.push(newItem)
        })
        this.selectRetailCount(count)
        this.changeStep(2)
      },
      submitVerify() {
        const o = this.form.natureEnquiry == 2 && this.formMode == 'retail' ? '' : this.form.orderNumber
        const p = this.productSelected.filter(a => {
          return (a.orderNumber == o && a.actionSelected == this.form.natureEnquiry) ||
            ((!o || o.length == 0) && (!a.orderNumer || a.orderNumber.length == 0) && a.actionSelected == this.form.natureEnquiry)
        })

        if (p && p.length > 0) {
          if (this.form.natureEnquiry == 2 && this.formMode == 'retail') {
            for (var i = 0; i < p.length; i++) {
              //window.console.log(p[i])
              if (p[i].orderNumber && p[i].orderNumber.length > 0) continue
              if (
                !p[i].purchaseProof || p[i].purchaseProof.length == 0 ||
                !p[i].purchaseDate || p[i].purchaseDate.length == 0
              ) {
                this.showUploadFileMsg = true
                setTimeout(() => { this.showUploadFileMsg = false }, 1000*12)
                return false
              }
              // if (!p[i].serialNumber || p[i].serialNumber.length == 0) {
              //   this.showSerialNumMsg = true
              //   setTimeout(() => { this.showSerialNumMsg = false }, 1000 * 8)
              //   return false
              // }
            }
          }
          return true
        }
        else
          this.showSelectProductMsg = true
        return false
      },
      submit() {
        if (!this.submitVerify()) return
        this.sending = true
        this.showPageLoading()
        this.$http.post(`${apiServer}/api/your-products/service-required`, {
          natureEnquiry: this.form.natureEnquiry,
          items: this.productSelected,
          orderNumber: this.form.natureEnquiry == 2 && this.formMode == 'retail' ? '' : this.form.orderNumber,
          store: this.store
        }, { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).then(({ data }) => {
          this.hidePageLoading()
          this.sending = false
          if (data && data.status == 'success'){
            localStorage.rma_step2_enquiry = this.form.natureEnquiry
            localStorage.rma_step2_formMode = this.formMode
            this.changeStep(3)
          }
          else
            this.showErrorMsg = true
        }).catch(() => {
          this.hidePageLoading()
          this.sending = false
          this.showErrorMsg = true
        })
      },
      contactus() {
        if (this.form.natureEnquiry != 4) return
        this.sending = true
        this.showPageLoading()
        this.$http.post(`${apiServer}/api/your-products/service-required`, {
          natureEnquiry: this.form.natureEnquiry,
          orderNumber: '',
          rmaNumber: this.form.rmaNumber,
          store: this.store
        }, { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).then(({ data }) => {
          this.hidePageLoading()
          this.sending = false
          if (data && data.status == 'success')
            this.changeStep(3)
          else
            this.showErrorMsg = true
        }).catch(() => {
          this.hidePageLoading()
          this.sending = false
          this.showErrorMsg = true
        })
      },
      contactUsForProof() {
        this.sending = true
        this.showPageLoading()
        this.$http.post(`${apiServer}/api/your-products/service-required`, {
          natureEnquiry: 5,
          orderNumber: '',
          rmaNumber: '',
          store: this.store
        }, { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).then(({ data }) => {
          this.hidePageLoading()
          this.sending = false
          if (data && data.status == 'success')
            this.changeStep(3)
          else
            this.showErrorMsg = true
        }).catch(() => {
          this.hidePageLoading()
          this.sending = false
          this.showErrorMsg = true
        })
      },
      changeFormMode(mode) {
        if (this.form.natureEnquiry == 2) {
          this.formMode = mode
          this.loadOrderDetail()
          this.loadRetailDetail()
        }
        this.changeStep(2)
      },
      changeServiceRequired() {
   //    window.console.log(this.form.natureEnquiry, this.formMode)
       if(this.form.natureEnquiry != 2 || !this.formMode || this.formMode.length == 0) this.formMode = 'estore'
       if(this.form.natureEnquiry != 4 && this.formMode == 'rma-status') this.formMode = 'estore'
       this.loadOrderDetail()
       this.loadRetailDetail()
       this.changeStep(2)
      },
      refreshOrder() {
        this.loadOrderDetail()
        this.showSelectProductMsg = false
      },
      refreshRetailList() {
        this.loadRetailDetail()
        this.showSelectProductMsg = false
      },
      scrollToSection() {
        window.console.log('section scroll')
        this.$scrollTo('#your-enquiry')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~vue-material/dist/theme/engine";

  .md-error {
    font-size: 0.9em !important;
  }
</style>
